import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { Button } from "@/shared/ui";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import { changeCurrentTenantId } from "@/domains/estate/slice";
import useResidentsHandlers from "@/domains/estate/hooks/handlers/useTenantsHandlers.ts";
import useLoadTenants from "@/domains/estate/hooks/useLoadTenants.ts";
import EstateTenantInfo from "@/domains/estate/components/tenants/EstateTenantInfo";
import EstateTenantsList from "@/domains/estate/components/tenants/EstateTenantsList";

export default function EstateTenantsContainer({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation("estate");
  const dispatch = useAppDispatch();
  const { loadTenants } = useLoadTenants();
  const {
    changeCurrentTenantIdHandler,
    updateTenantHandler,
    tenants,
    currentTenant,
    isRemoving,
    removeCurrentTenantHandler,
    backHandler,
    isUpdating,
  } = useResidentsHandlers();

  useEffect(() => {
    loadTenants();
  }, [loadTenants]);

  useEffect(() => {
    return () => {
      dispatch(changeCurrentTenantId());
    };
  }, [dispatch]);

  const disabledFooterButtons = useMemo(() => isRemoving || isUpdating, [isRemoving, isUpdating]);

  const header = currentTenant ? (
    <div className="flex items-center gap-2.5">
      <Button
        variant="soft"
        color="gray"
        className="p-0 w-[2rem] h-[2rem] shrink-0 font-arial text-[0.7rem]"
        onClick={backHandler}
      >
        &#9668;
      </Button>
      <div className="text-18 text-white font-bold">{t("estate.tenant.info")}</div>
    </div>
  ) : (
    t("estate.tabs.tenants")
  );

  const footer = currentTenant ? (
    <Button
      className="h-[2.5rem]"
      loading={isRemoving}
      disabled={disabledFooterButtons}
      onClick={removeCurrentTenantHandler}
    >
      {t("estate.tenant.remove")}
    </Button>
  ) : null;

  return (
    <DeviceTabContentWrapper
      header={header}
      footer={footer}
      withGradient={!currentTenant}
      onClose={onClose}
      className="p-0"
    >
      {currentTenant ? (
        <EstateTenantInfo tenant={currentTenant} onChange={updateTenantHandler} />
      ) : (
        <EstateTenantsList
          residents={tenants.data}
          onChange={changeCurrentTenantIdHandler}
          className="grow"
          onCall={(id: number) => {
            console.log(id);
          }}
          onMsg={(id: number) => {
            console.log(id);
          }}
        />
      )}
    </DeviceTabContentWrapper>
  );
}
